import { Component, EventEmitter } from '@angular/core';
import { MaterializeDirective, MaterializeAction } from 'angular2-materialize';
import { Subscription } from 'rxjs/Subscription';
import { Router } from '@angular/router';

import { CommonService } from '../../navbar/searchCommon.service';
import { SharedService } from '../../shared/shared.service';




@Component({
    selector: 'advanced-search-chips',
    templateUrl: './searchchips.component.html',
    styleUrls: ['./searchchips.component.css']
  })
export class AdvancedSearchChipsComponent {

  public chipArray = [];
  private subscription: Subscription;

  statusArray: any = [];
  ownerArray: any = [];
  materialArray: any = [];
  customerArray: any = [];
  customerContactsArray: any = [];
  DateRangeArray: any = ['1 week', '2 weeks', '1 month', '2 months', '6 months', '1 year'];

  searchData: any = [];
  page: string;

  constructor(private commonService: CommonService, private router: Router, private service: SharedService) {  }

  ngOnInit() {
    this.service.getCorporateInfo().subscribe(
        data => {
          let jdata = JSON.parse(data);
          this.customerArray = jdata.customers;
          this.materialArray = jdata.materials;
          this.ownerArray = jdata.owners;
          this.statusArray = jdata.statuses;
          this.customerContactsArray = jdata.customercontacts;
        },
        error => {

        }
    );
    this.subscription = this.commonService.notifyObservable$.subscribe(
      (res) => {
        if (res.hasOwnProperty('option') && res.option === 'onSearchFromNav') {


          if (this.chipArray.length > 0) {
            this.chipArray = [];
          }
          // probably just set a chip with the search value in quotes like CarMax does

        } else {
          if (res.hasOwnProperty('option') && res.option === 'onAdvancedSearch') {
            this.chipArray = [];
            this.page = res.value.page;
            this.searchData = res.value.data;
            this.updateChip();
          }
        }
      }
    );
  }


  updateChip() {

    this.chipArray = [];

    if (this.router.url !== '/workspace') { // We don't want to show chips on the workspace page
      switch (this.page) {
        case 'projects':

          if (this.searchData.name) {
            this.chipArray.push({ element: 'Project Name', value: 0, name: this.searchData.name });
          }
          if (this.searchData.number) {
            this.chipArray.push({ element: 'Part Number', value: 0, name: this.searchData.number });
          }
          if (this.searchData.revision) {
            this.chipArray.push({ element: 'Revision', value: 0, name: this.searchData.revision });
          }
          if (this.searchData.material) {
              let obj = this.materialArray.find(o => o.id === this.searchData.material);
            this.chipArray.push({ element: 'Material', value: this.searchData.material, name: obj.name });
          }
          if (this.searchData.customer) {
              let obj = this.customerArray.find(o => o.id === this.searchData.customer);
              this.chipArray.push({ element: 'Customer', value: this.searchData.customer, name: obj.name });
            }
          if (this.searchData.owner) {
              let obj = this.ownerArray.find(o => o.id === this.searchData.owner);
              this.chipArray.push({ element: 'Owner', value: this.searchData.owner, name: obj.email });
          }
          if (this.searchData.status) {
              let obj = this.statusArray.find(o => o.id === this.searchData.status);
            this.chipArray.push({ element: 'Status', value: this.searchData.status, name: obj.name });
          }
          if (this.searchData.createddays && this.searchData.createddate) {
            let createdWithin = this.DateRangeArray[this.searchData.createddays] + ' of ' + this.searchData.createddate;
            this.chipArray.push({ element: 'Created within', value: this.searchData.createddays, name: createdWithin });
          }
        break;

        case 'quotes':

          if (this.searchData.number) {
            this.chipArray.push({ element: 'Quote Number', value: 0, name: this.searchData.number });
          }
          if (this.searchData.createddays && this.searchData.createddate) {
            let createdWithin = this.DateRangeArray[this.searchData.createddays] + ' of ' + this.searchData.createddate;
            this.chipArray.push({ element: 'Created within', value: this.searchData.createddays, name: createdWithin });
          }
          if (this.searchData.RFQ) {
            this.chipArray.push({ element: 'RFQ', value: 0, name: this.searchData.RFQ });
          }
          if (this.searchData.customer) {
              let obj = this.customerArray.find(o => o.id === this.searchData.customer);
              this.chipArray.push({ element: 'Customer', value: this.searchData.customer, name: obj.name });
            }
          if (this.searchData.contact) {
              let obj = this.customerContactsArray.find(o => o.id === this.searchData.contact);
              this.chipArray.push({ element: 'Contact', value: this.searchData.contact, name: obj.firstname + ' ' + obj.lastname });
          }
          if (this.searchData.duedays && this.searchData.duedate) {
            let dueWithin = this.DateRangeArray[this.searchData.duedays] + ' of ' + this.searchData.duedate;
            this.chipArray.push({ element: 'Due within', value: this.searchData.dueddays, name: dueWithin });
          }
          if (this.searchData.owner) {
            let obj = this.ownerArray.find(o => o.id === this.searchData.owner);
            this.chipArray.push({ element: 'Owner', value: this.searchData.owner, name: obj.email });
          }
          if (this.searchData.status) {
            let obj = this.statusArray.find(o => o.id === this.searchData.status);
            this.chipArray.push({ element: 'Status', value: this.searchData.status, name: obj.name });
          }
          if (this.searchData.expireddays && this.searchData.expireddate) {
            let expiredWithin = this.DateRangeArray[this.searchData.expireddays] + ' of ' + this.searchData.expireddate;
            this.chipArray.push({ element: 'Expires within', value: this.searchData.expireddays, name: expiredWithin });
          }
        break;
      }
    }
  }


  editAdvancedSearch() {
    this.commonService.notifyOther({ option: 'onAdvancedSearchEdit', value: {page: this.page, data: this.searchData} });
  }


  removechip(chip) {

    switch (this.page) {
      case 'projects':

        switch (chip.element) {
          case 'Project Name':
            this.searchData.name = undefined;
            break;
          case 'Part Number':
            this.searchData.number = undefined;
            break;
          case 'Revision':
            this.searchData.revision = undefined;
            break;
          case 'Material':
            this.searchData.material = undefined;
            break;
          case 'Customer':
            this.searchData.customer = undefined;
            break;
          case 'Owner':
            this.searchData.owner = undefined;
            break;
          case 'Status':
            this.searchData.status = undefined;
            break;
          case 'Created within':
            this.searchData.createddate = undefined;
            this.searchData.createddays = '1 week';
            break;
          default:
            break;
        }

      break;

      case 'quotes':
        switch (chip.element) {
          case 'Quote Number':
            this.searchData.number = undefined;
            break;
          case 'Created within':
            this.searchData.createddate = undefined;
            this.searchData.createddays = '1 week';
            break;
          case 'RFQ':
            this.searchData.RFQ = undefined;
            break;
          case 'Revision':
            this.searchData.revision = undefined;
            break;
          case 'Customer':
            this.searchData.customer = undefined;
            break;
          case 'Contact':
            this.searchData.contact = undefined;
            break;
          case 'Due within':
            this.searchData.duedate = undefined;
            this.searchData.duedays = '1 week';
            break;
          case 'Owner':
            this.searchData.owner = undefined;
            break;
          case 'Status':
            this.searchData.status = undefined;
            break;
          case 'Expires within':
            this.searchData.expireddate = undefined;
            this.searchData.expireddays = '1 week';
            break;
          default:
            break;
        }
      break;
    }
    this.chipArray.splice(this.chipArray.indexOf(chip), 1);
    if (this.chipArray.length) {
        this.commonService.notifyOther({ option: 'onAdvancedSearch', value: {page: this.page, data: this.searchData} });
    } else {
        this.commonService.notifyOther({ option: 'onAdvancedSearch', value: {page: this.page, data: ''} });
    }
  }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/search/chips/searchchips.component.ts